import styled from "styled-components";

import { Modal } from "components/Modal";

export const CompletionModalContainer = styled(Modal)`
  .modal-dialog {
    max-width: 512px;

    .modal-content {
      padding: 2rem;

      .modal-body {
        padding: 0;
        margin-top: 0;
        text-align: center;

        h2 {
          color: ${({ theme }) => theme.card.font.tertiary};
          text-align: center;
          font-size: 20px;
          font-weight: 500;
          padding-top: 20px;
          margin-bottom: 0px;
        }

        .description {
          margin: 14px 0;
          font-size: 15px;
        }

        button {
          width: 100%;
          font-weight: 500;
          font-size: 14px;
        }
      }
    }
  }
`;
